import { Component, OnInit, Inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { Tema } from '../../../../models/tema';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { TemaService } from '../../../../services/tema.service';
import { DialogService } from '../../../../services/dialog.service';
import { ToastService } from '../../../../services/toast.service';
import { AuthService } from '../../../core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-adm-tema',
  templateUrl: './adm-tema.component.html',
  styleUrls: ['./adm-tema.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdmTemaComponent implements OnInit {
  displayedColumns: string[] = ['id', 'nome', 'urlCurta', 'actions'];
  dataSource: any = [];
  public tema: Tema;
  submitted = false;
  error = '';

  active: boolean = false;
  saving: boolean = false;
  formTema: UntypedFormGroup;

  constructor(
    private authorizeService: AuthService,
    private modalService: NgbModal,
    private temaService: TemaService,
    private dialogService: DialogService,
    private toastService: ToastService,
    private router: Router
  ) { }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngOnInit() {
    var user = this.authorizeService.getUser();
    if (user != null) {
      if (!user.isAdmin) {
        this.router.navigate(['/treino']);
      } else {
        this.loadGrid();
        this.createForm(new Tema());
      }
    } else {
      this.router.navigate(['/login'], {
        queryParams: { retUrl: '/adm/tema' }
      });
    }
  }

  get f() {
    return this.formTema.controls;
  }

  loadGrid() {
    this.temaService.get().subscribe((res) => {
      this.dataSource = new MatTableDataSource(res);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });
  }

  createForm(temaForm: Tema) {
    this.formTema = new UntypedFormGroup({
      id: new UntypedFormControl(temaForm.id),
      nome: new UntypedFormControl(temaForm.nome, Validators.required),
      urlCurta: new UntypedFormControl(temaForm.urlCurta),
      obs: new UntypedFormControl(temaForm.obs, Validators.required),
    });
  }

  open(content: any) {
    this.createForm(new Tema());
    this.modalService.open(content);
  }

  edit(content: any, id: number) {
    this.submitted = false;
    this.temaService.getById(id).subscribe((res) => {
      this.tema = res;
      this.formTema.setValue({
        id: this.tema.id,
        nome: this.tema.nome,
        urlCurta: this.tema.urlCurta,
        obs: this.tema.obs,
      });
    });
    this.modalService.open(content);
  }

  async deleteItem(id: number): Promise<void> {
    this.active = true;
    const confirmado = await this.dialogService.confirm('Deseja realmente excluir?', 'Tem certeza?');

    if (confirmado) {
      this.temaService.delete(id).subscribe({
        next: () => {
          this.toastService.show('Sucesso ao executar!', { type: 'success' });
          this.loadGrid();
        },
        error: () => {
          this.toastService.show('Não foi possível executar!', { type: 'danger' });
        },
      });
    }

  }

  create(content: any): void {
    this.createForm(new Tema());
    this.modalService.open(content);
  }

  submitForm() {
    this.submitted = true;

    if (this.formTema.invalid) {
      this.error = 'Informações inválidas';
      return;
    }
    this.tema = this.formTema.value;
    if (this.tema.id > 0) {
      this.temaService.put(this.tema.id, this.tema).subscribe({
        next: (res) => {
          this.tema = res;
          this.loadGrid();
          this.toastService.show('Sucesso ao executar!', { type: 'success' })
          this.modalService.dismissAll();
        },
        error: () => {
          this.toastService.show('Não foi possível executar!', { type: 'danger' })
        },
      });
    } else {
      this.tema.id = 0;
      this.temaService.post(this.tema).subscribe({
        next: () => {
          this.toastService.show('Sucesso ao executar!', { type: 'success' })
          this.loadGrid();
          this.modalService.dismissAll();
        },
        error: (err) => {
          this.toastService.show('Não foi possível executar!', { type: 'danger' })
        },
      });
    }
  }
}
